import { Modal } from "antd5";

import { convertNoticeFiltersToView } from "components/notices/utils";
import { toast } from "components/ui/toast/Toast";
import { SavedViewForm } from "components/views/SavedViewForm";
import { useCreateSavedView } from "lib/hooks/api/saved_views/useCreateSavedView";
import { SignalSettings } from "lib/hooks/api/teams/useSignalSettings";
import { CreateSavedViewAlertFrequency, SavedViewDataType } from "lib/types/graphQLEnums";
import { SavedViewDataTypeUnion } from "lib/types/savedViews";
import { useNoticeListsPageState } from "../useNoticeListsPageState";

import css from "./CreateViewModal.module.scss";

type CreateViewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  signals?: SignalSettings;
  dataType: SavedViewDataTypeUnion;
};

export function CreateViewModal({ isOpen, onClose, signals, dataType }: CreateViewModalProps) {
  const { filters, tableColumns, setSelectedView } = useNoticeListsPageState();

  const { mutate: createView, isLoading: isCreatingView } = useCreateSavedView({
    onSuccess: async (data) => {
      setSelectedView(data.createSavedView.id, data.createSavedView.name, "Create view modal");
      onClose();
      toast.success(`Successfully created ${data.createSavedView.name}`);
    },
    onError: async (_data, vars) => {
      onClose();
      toast.error(`Failed to create ${vars.request.name}`);
    },
  });

  return (
    <Modal
      className={css.modal}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      title={"Save search"}
    >
      <p className={css.modalDescription}>
        Quickly access your most commonly used filters at anytime by creating filtered searches.
      </p>
      <SavedViewForm
        defaultValues={{
          viewName: "",
          viewDescription: "",
          alertFrequency: "DAILY",
        }}
        onSubmit={(data) => {
          createView({
            request: {
              name: data.viewName,
              description: data.viewDescription ?? "",
              dataType: dataType as SavedViewDataType,
              view: JSON.stringify(convertNoticeFiltersToView(filters, tableColumns, signals)),
              alertFrequency:
                data.alertFrequency === "NEVER"
                  ? undefined
                  : (data.alertFrequency as CreateSavedViewAlertFrequency),
            },
          });
        }}
        onCancel={onClose}
        isLoading={isCreatingView}
      />
    </Modal>
  );
}
